module.exports = __webpack_public_path__ + "static/media/request-wally.9a68b6ab.svg";